/*
 * 模块: PeriodManagementSection
 * 职责: 周期管理可折叠区域
 * 依赖: antd, PeriodSelector
 * 导出: PeriodManagementSection
 * 限制: 文件<100行, 函数<30行
 */

import React from 'react';
import { Collapse } from 'antd';
import { PeriodSelector } from '../PeriodSelector';
import type { Period } from '../../types';

interface PeriodManagementSectionProps {
  periods: Period[];
  skuId: number;
  onPeriodUploaded: () => void;
}

/**
 * 周期管理区域组件
 * 可折叠展示周期上传和管理功能
 */
export const PeriodManagementSection: React.FC<PeriodManagementSectionProps> = ({
  periods,
  skuId,
  onPeriodUploaded,
}) => {
  return (
    <Collapse
      defaultActiveKey={[]}
      className="period-management-collapse"
      items={[
        {
          key: '1',
          label: (
            <span style={{ fontSize: 16, fontWeight: 500 }}>
              周期管理
              <span style={{ color: '#999', fontSize: 14, fontWeight: 400, marginLeft: 8 }}>
                已上传 {periods.length} 个周期
              </span>
            </span>
          ),
          children: (
            <div>
              <p style={{ color: '#666', marginBottom: 16 }}>
                已上传 {periods.length} 个周期的数据，下方显示基于所有周期计算的聚合指标
              </p>
              <PeriodSelector
                periods={periods}
                selectedPeriodId={undefined}
                onPeriodSelect={() => { }}
                onPeriodUploaded={onPeriodUploaded}
                skuId={skuId}
              />
            </div>
          )
        }
      ]}
    />
  );
};

